// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################


export const ADR = 'ADR';

export const POB = 'POB';

/**
 * Seznam všech hodnot.
 */
export const values = [
    ADR,
    POB
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [ADR]: {caption: ''},
    [POB]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}